import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from '@/contexts/AuthContext';
import AppInitializer from './components/layout/AppInitializer';
import { UserMessagesProvider } from './contexts/UserMessagesContext';
import { LocalLLMProvider } from '@/contexts/LocalLLMContext';

import { TitleBar } from '@/components/TitleBar';

// Import all page components
import Index from './pages/Index';
import Auth from './pages/Auth';
import Chat from './pages/Chat';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import KnowledgeBase from './pages/KnowledgeBase';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Code from './pages/Code';
import Canvas from './pages/Canvas';
import Users from './pages/Users';
import Community from './pages/Community';
import Lobby from './pages/Lobby';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Purchase from './pages/Purchase';
import About from './pages/About';
import Downloads from './pages/Downloads';
import Eula from './pages/Eula';
import BugReports from './pages/BugReports';
import MCPServices from './pages/MCPServices';
import Data from './pages/Data';

import Docs from './pages/Docs';
import AcceptInvitation from './pages/AcceptInvitation';
import NotFound from './pages/NotFound';
import AgentMarketplace from './pages/agents/AgentMarketplace';
import ProfessionalAgents from './pages/agents/ProfessionalAgents';
import ScientificAgents from './pages/agents/ScientificAgents';
import CustomAgent from './pages/agents/CustomAgent';
import UseAgent from './pages/agents/UseAgent';
import LandingPage from './pages/LandingPage';
import Partnership from './pages/Partnership';
import MaplePT from './pages/MaplePT';
import CompleteRegistrationPage from './pages/CompleteRegistration';
import AccessControl from './pages/AccessControl';

function App() {
  return (
    <AuthProvider>
      <UserMessagesProvider>
        <LocalLLMProvider>
          <TitleBar />
          <AppInitializer />
          <Toaster />
        </LocalLLMProvider>
      </UserMessagesProvider>
    </AuthProvider>
  );
}

export default App;